/**
 * Tinted icon-tile tones for channel surfaces.
 *
 * The Channels redesign renders every provider glyph inside a soft tinted tile
 * so the catalogue and the connected list read as one system. Tones stay inside
 * the `n-*` token families, and the mapping is keyed off provider identity so a
 * channel looks the same wherever it appears.
 */
import { INBOX_TYPES, TWILIO_CHANNEL_MEDIUM } from './inbox';

export const DEFAULT_CHANNEL_TONE = 'slate';

export const CHANNEL_TONES = {
  violet: 'bg-n-violet-3 text-n-violet-11',
  iris: 'bg-n-iris-3 text-n-iris-11',
  blue: 'bg-n-blue-3 text-n-blue-11',
  teal: 'bg-n-teal-3 text-n-teal-11',
  ruby: 'bg-n-ruby-3 text-n-ruby-11',
  amber: 'bg-n-amber-3 text-n-amber-11',
  slate: 'bg-n-slate-3 text-n-slate-11',
};

// Catalogue cards and provider pickers identify a channel by its short slug.
const TONE_BY_CHANNEL_KEY = {
  website: 'violet',
  facebook: 'iris',
  whatsapp: 'teal',
  whatsapp_call: 'teal',
  whatsapp_cloud: 'teal',
  line: 'teal',
  email: 'blue',
  gmail: 'blue',
  google: 'blue',
  outlook: 'blue',
  microsoft: 'blue',
  telegram: 'blue',
  twitter: 'blue',
  instagram: 'ruby',
  twilio: 'ruby',
  voice: 'amber',
  sms: 'slate',
  api: 'slate',
  tiktok: 'slate',
};

// Connected inboxes only carry their `Channel::` class name.
const TONE_BY_CHANNEL_TYPE = {
  [INBOX_TYPES.WEB]: 'violet',
  [INBOX_TYPES.FB]: 'iris',
  [INBOX_TYPES.WHATSAPP]: 'teal',
  [INBOX_TYPES.LINE]: 'teal',
  [INBOX_TYPES.EMAIL]: 'blue',
  [INBOX_TYPES.TELEGRAM]: 'blue',
  [INBOX_TYPES.TWITTER]: 'blue',
  [INBOX_TYPES.INSTAGRAM]: 'ruby',
  [INBOX_TYPES.TWILIO]: 'slate',
  [INBOX_TYPES.SMS]: 'slate',
  [INBOX_TYPES.API]: 'slate',
  [INBOX_TYPES.TIKTOK]: 'slate',
};

export const toneClassesFor = tone =>
  CHANNEL_TONES[tone] ?? CHANNEL_TONES[DEFAULT_CHANNEL_TONE];

export const toneForChannelKey = key =>
  TONE_BY_CHANNEL_KEY[key] ?? DEFAULT_CHANNEL_TONE;

export const toneForInbox = inbox => {
  // Twilio carries both SMS and WhatsApp traffic; follow the medium so a Twilio
  // WhatsApp inbox reads as WhatsApp, exactly like its icon does.
  if (
    inbox?.channel_type === INBOX_TYPES.TWILIO &&
    inbox?.medium === TWILIO_CHANNEL_MEDIUM.WHATSAPP
  ) {
    return 'teal';
  }

  return TONE_BY_CHANNEL_TYPE[inbox?.channel_type] ?? DEFAULT_CHANNEL_TONE;
};
